<form #f="ngForm" [formGroup]="phoneForm">
  <div class="custom-nb-phone-input">
    <ngx-intl-tel-input
      [required]="required"
      [enableAutoCountrySelect]="true" 
      [enablePlaceholder]="true" 
      [searchCountryFlag]="true"
      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" 
      [selectFirstCountry]="false"
      [selectedCountryISO]="CountryISO.France" 
      [maxLength]="20"
      [phoneValidation]="true" 
      [separateDialCode]="separateDialCode"
      [numberFormat]="PhoneNumberFormat.National" 
      name="phone" 
      formControlName="{{controlName}}"
      (ngModelChange)="onPhoneChange($event)">
    </ngx-intl-tel-input>
  </div>
</form>